// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlidersFilledSvg from "@ant-design/icons-svg/es/asn/SlidersFilled";
import AntdIcon from '../components/AntdIcon';

var SlidersFilled = function SlidersFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlidersFilledSvg
  }));
};

SlidersFilled.displayName = 'SlidersFilled';
export default React.forwardRef(SlidersFilled);